/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Activity_TitleInputs */

const en_analytics_activity_title = /** @type {(inputs: Analytics_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application Activity`)
};

const de_analytics_activity_title = /** @type {(inputs: Analytics_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungsaktivität`)
};

const fr_analytics_activity_title = /** @type {(inputs: Analytics_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activité de candidature`)
};

const es_analytics_activity_title = /** @type {(inputs: Analytics_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividad de solicitudes`)
};

const it_analytics_activity_title = /** @type {(inputs: Analytics_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attività di candidatura`)
};

const nl_analytics_activity_title = /** @type {(inputs: Analytics_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatieactiviteit`)
};

const pl_analytics_activity_title = /** @type {(inputs: Analytics_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktywność aplikacyjna`)
};

const fi_analytics_activity_title = /** @type {(inputs: Analytics_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakemustoiminta`)
};

const da_analytics_activity_title = /** @type {(inputs: Analytics_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgningsaktivitet`)
};

const sv_analytics_activity_title = /** @type {(inputs: Analytics_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansökningsaktivitet`)
};

/**
* | output |
* | --- |
* | "Application Activity" |
*
* @param {Analytics_Activity_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_activity_title = /** @type {((inputs?: Analytics_Activity_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Activity_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_activity_title(inputs)
	if (locale === "fr") return fr_analytics_activity_title(inputs)
	if (locale === "es") return es_analytics_activity_title(inputs)
	if (locale === "it") return it_analytics_activity_title(inputs)
	if (locale === "nl") return nl_analytics_activity_title(inputs)
	if (locale === "pl") return pl_analytics_activity_title(inputs)
	if (locale === "fi") return fi_analytics_activity_title(inputs)
	if (locale === "da") return da_analytics_activity_title(inputs)
	if (locale === "sv") return sv_analytics_activity_title(inputs)
	return en_analytics_activity_title(inputs)
});